import { render, staticRenderFns } from "./teacher-grade-view.vue?vue&type=template&id=7bc2e801&"
import script from "./teacher-grade-view.vue?vue&type=script&lang=js&"
export * from "./teacher-grade-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports